import actionTypes from './actionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../util/createReducer';

const INITIAL_STATE = {
  isFetching: false,
  isLoadingPaymentForm: false,
  error: null,
  response: null,
  currentStep: null,
};

const reducer = createReducer(INITIAL_STATE, {
  [actionTypes.CREATE_PAYMENT_METHOD_UPDATE_PAGE_START]: (state: any) => {
    return {
      ...state,
      isFetching: true,
      error: null,
      response: null,
    };
  },
  [actionTypes.CREATE_PAYMENT_METHOD_UPDATE_PAGE_SUCCESS]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      isFetching: false,
      error: null,
      response: action.response,
      currentStep: 'payment-method-update',
      isLoadingPaymentForm: true,
    };
  },
  [actionTypes.CREATE_PAYMENT_METHOD_UPDATE_PAGE_ERROR]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      isFetching: false,
      error: action.error,
      response: null,
      isLoadingPaymentForm: false,
    };
  },
  [actionTypes.PAYMENT_METHOD_UPDATE_START]: (state: any) => {
    return {
      ...state,
      isFetching: true,
    };
  },
  [actionTypes.PAYMENT_METHOD_UPDATE_PAGE_LOADED]: (state: any) => {
    return {
      ...state,
      isFetching: false,
      isLoadingPaymentForm: false,
    };
  },
  [actionTypes.PAYMENT_METHOD_UPDATE_SUCCESS]: (state: any) => {
    return {
      ...state,
      isFetching: false,
      currentStep: 'payment-method-update-success',
    };
  },
  [actionTypes.PAYMENT_METHOD_UPDATE_FAIL]: (state: any, action: any) => {
    return {
      ...state,
      isFetching: false,
      error: action.error,
      currentStep: 'payment-method-update-error',
    };
  },
  [actionTypes.PAYMENT_METHOD_UPDATE_RESET]: () => {
    return INITIAL_STATE;
  },
});

export default reducer;
